import { inject } from '@angular/core';
import {
  CanActivateFn,
  Router,
  type MaybeAsync,
  type GuardResult,
} from '@angular/router';
import { map } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import { PermissionsService } from '@infra-adapters/services/permissions.service';

/**
 * Bloquea el acceso a una ruta si el usuario no posee el permiso requerido.
 * El permiso se declara en `data.permission` (string o string[] = se exige al menos uno).
 * Rutas sin `data.permission` pasan con solo estar autenticadas (AuthGuard).
 *
 * Debe encadenarse DESPUÉS de AuthGuard.
 */
export const PermissionGuard: CanActivateFn = (route): MaybeAsync<GuardResult> => {
  const permissionsService = inject(PermissionsService);
  const router = inject(Router);
  const toastr = inject(ToastrService);

  const required = route.data?.['permission'] as string | string[] | undefined;

  return permissionsService.ensureLoaded().pipe(
    map(() => {
      if (!required) {
        return true;
      }
      const keys = Array.isArray(required) ? required : [required];
      if (permissionsService.hasAny(keys)) {
        return true;
      }
      toastr.error('No tienes permiso para acceder a esta sección');
      return router.createUrlTree(['/dashboard']);
    }),
  );
};
